(function () {
  'use strict';

  function getPrice() {
    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl) { return parseInt(priceEl.getAttribute('data-product-price'), 10) / 100; }
    return null;
  }

  function toggleKlarnaWhenReady() {
    const observer = new MutationObserver(function () {
      const klarnaWidget = document.querySelector('[data-key="credit-promotion-badge"]');
      const price = getPrice();
      if (klarnaWidget && price !== null) {
        if (price <= 35) {
          klarnaWidget.style.setProperty('display', 'none', 'important');
        } else {
          klarnaWidget.style.setProperty('display', 'block', 'important');
        }
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    toggleKlarnaWhenReady();
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="id"]')) { setTimeout(toggleKlarnaWhenReady, 500); }
    });
  });
})();
